/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SelectOTPLoginDataParser = /* #__PURE__ */ parsers.object([
    ['code', codecString],
    ['userId', codecNumber, 'user_id'],
    [
        'confirmSessionTermination',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'confirm_session_termination',
    ],
]);
export class SelectOTPLoginData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SelectOTPLoginDataParser.decode(input).map(res => new SelectOTPLoginData(res));
    }
    static unsafeDecode(input) {
        return SelectOTPLoginData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SelectOTPLoginDataParser.encode(data);
    }
    static schema() {
        return SelectOTPLoginDataParser.schema();
    }
}
